<mat-radio-group
  [id]="id + '-mrg'"
  [attr.aria-label]="ariaLabel"
  class="flex radio-content"
  [(ngModel)]="value"
  (ngModelChange)="changeRadioButtonValue()"
>
  <div
    [id]="id + '-c'"
    class="flex flex-row radio-button-row aic"
    [class.jcsb]="buttonPosition === 'right'"
    [class.selected]="highlightItem === template.value"
    *ngFor="let template of radioButtonsTemplates; let idx = index"
  >
    <mat-radio-button
      [id]="'radio' + idx"
      *ngIf="buttonPosition === 'left'"
      class="radio-button"
      [value]="template.value"
    >
    </mat-radio-button>
    <ng-template [ngTemplateOutlet]="template.templateRef"></ng-template>
    <mat-radio-button
      [id]="id + '-mrb'"
      *ngIf="buttonPosition === 'right'"
      class="radio-button"
      [value]="template.value"
    >
    </mat-radio-button>
  </div>
</mat-radio-group>
